export default "__VITE_ASSET__BttOL11g__"